import { appBackgroundColor } from 'globals/colors';

const styles = {
  articleContainer: {
    padding: '5px 16px 25px',
    backgroundColor: appBackgroundColor,
  },
};

export default styles;
